import { Switch, Route, Redirect} from 'react-router-dom'

// Components
import Index from './views/index'
import Login from './containers/login/login'

function App () {
	return (
		<div className="app">
			<Switch>
				<Route exact path="/login" component={Login}/>
				<Route path="/" component={Index}/>
				<Route path="*">
					<Redirect to="/" />
				</Route>
			</Switch>
		</div> 
	);

}

export default App;
